$( document ).ready(function() {
/******************** Technical specification start js **************************/
  $('body').on('click', '.cstm-jtpl-close-btn', function(){ 
      $('html, body').animate({
          scrollTop: $(".jtpl-metaobject-multicolumn").offset().top-100}
      ,1000);
    });
  /******************** Technical specification end js **************************/

  
  /******************** Social share link to copy start js **************************/
  
    $('.social-share__heading').click(function(){
        // Get the data-share-url attribute from the button element
        var textToCopy = $(this).find('.sharing-button').attr('data-share-url');

        // Create a temporary textarea element
        var tempTextArea = document.createElement("textarea");
        // Set the textarea's value to the text you want to copy
        tempTextArea.value = textToCopy;
        // Append the textarea to the document body (required for copying)
        document.body.appendChild(tempTextArea);
        // Select the text
        tempTextArea.select();
        // Copy the text
        try {
            var successful = document.execCommand('copy');
            if (successful) {
                alert('Text copied to clipboard');
            } else {
                alert('Oops, unable to copy');
            }
        } catch (err) {
            alert('Oops, unable to copy');
        }
        // Remove the temporary textarea
        document.body.removeChild(tempTextArea);
    });
/******************** Social share link to copy end js **************************/

});

/******************** Technical specification start js **************************/
//  $(document).ready(function() {
//   var selectElement = $('#tagfilter');
//   var imageElements = $('.collection-banner__media img');

//   selectElement.change(function() {
//     var selectedOption = selectElement.find(':selected');
//     var dataImageId = selectedOption.attr('data-image');

//     // Hide all images
//     imageElements.hide();

//     // Show the selected image
//     var selectedImage = $('#' + dataImageId);
//     selectedImage.show();
//   });
// });
// $(document).ready(function() {
//   // Set default image when page loads
//   var defaultImage = '';
//   $('.selectedImage').attr('src');
 
//   // Event listener for change in select dropdown

$(document).ready(function() {
  // Set default image when page loads
 var defaultImageSrc = $('.selectedImage').attr('src');
  var defaultImage = new Image();
  defaultImage.src = defaultImageSrc;

  // Event listener for change in select dropdown
  $('body').on("change", '#tagfilter', function() {
    
    var selectedOption = $(this).val();
    var selectedValue = $.trim(selectedOption); // Trim any whitespace

    // Update the src attribute of the image if data-images attribute is defined
    var selectedImage = $(this).find('option:selected').attr('data-images');
    if (selectedImage) {
  
      $('.selectedImage').attr('src', selectedImage);
   
      $('.selectedImage').attr('alt', selectedOption);
        $('.selectedImage').show(); 
      console.log("if..");
    } else {
      // Handle case where selected option does not have data-images attribute
      console.log('No image found for selected option');
      // Reset to default image if needed
      $('.selectedImage').attr('src', defaultImage);
        $('.selectedImage').show(); 
    }

    // Set the selected attribute on the option that matches selectedValue
    $(this).find('option').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('selected', true);
      } else {
        $(this).prop('selected', false);
      }
    });

    // Construct the new URL with the selected value
    var currentUrl = window.location.href; // Get current URL
   var modifiedString = selectedValue.replace("TVS", "").trim(); // Remove "TVS" and trim any whitespace

// Replace spaces with '+'
var replaceUrl = modifiedString.replace(/\s+/g, '+');
console.log("replaceUrl", replaceUrl);
    // console.log("eplaceUrl", endUrl)
    var baseUrl = currentUrl.split('?')[0]; // Get base URL without query parameters
    location.href = baseUrl+ "?sort_by=best-selling&filter.p.m.tvs.brand="+ replaceUrl;
    
    // Update the URL without reloading the page
   // history.replaceState(null, null, location.href);
  });

  // Trigger change event to initially set selected option on page load

   /***************** customer login  ******************/
  $(".NewEmailCustomer").hide();
    $(".new-customer-jtpl").click(function(){
          $(".NewEmailCustomer").fadeIn(500);
        // $(this).hide();
    });

  $("label#smlAcceptPrivacypolicyText strong").click(function(){
     $(".Privacy-policy-popup").fadeIn(500);
    $("body").addClass("policy-popup-open");
    $("#smlAcceptPrivacypolicyCheckbox").trigger("click");
   });
  $(".Privacy-policy-popup .close-ixon").click(function(){
     $(".Privacy-policy-popup").fadeOut(200);
    $("body").removeClass("policy-popup-open");
   });
  $('.Privacy-policy-popup').click(function(e) {
    if(!$('.static_pages .close-ixon').is(e.target)){
      $('.Privacy-policy-popup').fadeOut(200);
        $("body").removeClass("policy-popup-open");
      }
    });

  var Interval = setInterval(login, 100);
  function login(){
    $("#otherLoginMethodsDiv").remove();
    clearInterval(Interval);
  }
  

});

document.addEventListener('DOMContentLoaded', function (){ 
  var selectedOption = $(this).val();
    var selectedValue = $.trim(selectedOption); // Trim any whitespace

    // Update the src attribute of the image if data-images attribute is defined
    var selectedImage = $(this).find('option:selected').attr('data-images');
    var defaultImageSrc = $('.selectedImage').attr('src');
    var defaultImage = new Image();
     defaultImage.src = defaultImageSrc;
    if (selectedImage) {
  
      $('.selectedImage').attr('src', selectedImage);
   
      $('.selectedImage').attr('alt', selectedOption);
        $('.selectedImage').show(); 
      console.log("if..");
    } else {
      // Handle case where selected option does not have data-images attribute
      console.log('No image found for selected option');
      // Reset to default image if needed
      $('.selectedImage').attr('src', defaultImageSrc );
        $('.selectedImage').show(); 
    }

  var filters = document.querySelector('.coll-filter');
  var filters = document.querySelector('.coll-filter');
  var opts = filters.querySelectorAll('option');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let tagUrl = urlParams.get('filter.p.m.tvs.brand');

  if (!tagUrl) return;

  tagUrl = tagUrl.replaceAll(' ','+')
  console.log("tagUrl: ",tagUrl)

  for (let i = 0 ; i<opts.length;i++){
    var val = opts[i].getAttribute("value");
   var img_src = opts[i].getAttribute("data-images");
    console.log(val)
    if (val){
      var optValue = val.toString().replaceAll('-','+').toUpperCase();
      console.log(optValue)
    optValue =   optValue.replaceAll("TVS","").trim().replaceAll(" ","+");
        console.log(tagUrl+"===="+optValue)
    if (tagUrl == optValue){
        console.log("val : ",val)
        filters.value = val; 
        $(".collection-banner__media img").attr("src",img_src);
        break;
        
      }
    }
  }
});

